import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import { kolNonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { DeepReadonly } from '@src/utils/type-utils';
import { useTranslation } from 'next-i18next';
import React from 'react';

type Props = {
    betpickDetail: DeepReadonly<BetPickDetail>;
};

const STRIKE_STYLE =
    'text-white font-bold text-[16px] absolute left-[-1px] top-[-1px] rounded-br-lg bg-[#FF9900] py-1.5 pl-3 pr-2';

const RegularItemButton = ({ betpickDetail }: Props) => {
    const { t } = useTranslation('kol');

    const { betpick, race, raceDay } = betpickDetail;

    const isVoid = betpick.buttonStatus?.value === 'VOID';
    if (isVoid) {
        return <div className='text-center font-bold py-1'>{t('betpick.void')}</div>;
    }

    const formatTrackingSelection = (value?: string, scratched?: boolean) => {
        if (!value) return '';
        return scratched ? `${value}(${t('betpick.scratched')})` : value;
    };

    if (betpick.buttonStatus?.value === 'BetLink') {
        const selections = [
            formatTrackingSelection(betpick.bankerRow?.value, betpick.bankerRowSCR?.boolValue),
            formatTrackingSelection(betpick.selRow?.value, betpick.selRowSCR?.boolValue),
            formatTrackingSelection(betpick.selRow2nd?.value, betpick.selRow2ndSCR?.boolValue),
            formatTrackingSelection(betpick.selRow3rd?.value, betpick.selRow3rdSCR?.boolValue),
            formatTrackingSelection(betpick.selRow4th?.value, betpick.selRow4thSCR?.boolValue),
        ];

        const handleClick = () => {
            kolNonPageTracker({
                eventID: TrackingEvent.BetPickCTA,
                betLink: selections.filter((item) => item !== '').join(','),
                betType: betpick.betPickType?.targetItem?.betTypeName?.value,
                raceID: `${raceDay?.name}/${race?.name}`,
                kolName: betpick.kol?.targetItem?.name,
            });
        };

        return (
            <a
                href={betpick.betlineUrl?.value}
                target='_blank'
                className='h-[30px] mt-[12px] bg-[#FFD505] text-[16px] rounded-full flex items-center justify-center font-medium'
                onClick={handleClick}
            >
                {t('betpick.betNow')}
            </a>
        );
    }

    if (betpick.buttonStatus?.value === 'Strike') {
        return <div className={STRIKE_STYLE}>{t('betpick.strike')} 🎉</div>;
    }

    return null;
};

export default RegularItemButton;
